import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// GET /ajax/funding_sources/{district_id}
export const fundingSources = async (districtId: TDistrictId) => {
  const response = await new Request().get('/ajax/funding_sources/' + districtId)
  return Util.Obj.keysToCamel(response.data.funding_sources) as TFundingSource[]
}
